import * as $ from 'jquery';
import './validation';
import './prevent-dirty-submit';
import './prevent-submit-twice';
import './file-download-button';
import './components/details';
import './nav-tabs-hamburger-overflow';
import { Dropzone } from './components/dropzone';
import enhanceSortableTables from './components/shared/SortableTable';
import enhanceReorderableTables from './components/shared/ReorderableTable';

declare global {
  interface Window {
    ifunds: {
      strings: any,
      filePickerCache: [key: string]
    };
    rootUrl: string;
    messages: any;
    powerbiAccessToken: string; //zetten we in view dashboard.cshtml , homecontroller/dashboard action haalt on behalve of accestoken op.
    getValue: (name: string) => any;
  }
}

function copyIframeMessages() {
  const iframe = $('iframe[data-message]');
  iframe.contents().find('html').html(iframe.data('message'));
  iframe.contents().find('head').append($('<base target="_blank">'));
  iframe.contents().find('head').append($('<link rel="stylesheet" type="text/css" href="/css/message.css">'));

  const printDiv = iframe.siblings('.message-print-body');
  if (printDiv.length) {
    const doc = new DOMParser().parseFromString(iframe.data('message'), 'text/html');
    printDiv.html(doc.body ? doc.body.innerHTML : iframe.data('message'));
  }
}

$(function () {
  enhanceSortableTables();
  enhanceReorderableTables();
  copyIframeMessages();

  window.ifunds = (function (ifunds: any) {
    ifunds.filePickerCache = {};
    return ifunds;
  })(window.ifunds || {});

  let $document = $(document);

  $document.on('click', '.delete', function (e) {
    let question = $(e.target).data('confirmQuestion') ?? window.ifunds.strings.areYouSureToDeleteThis;
    return confirm(question);
  });

  $document.on('click', '.delete-attachment', function () {
    const attachment = $(this).closest('.attachment');
    attachment.addClass('marked-for-deletion');
    attachment.find('input[name=_deleteAttachment]').val(attachment.find('input[type=file]').attr('name'));
  });

  $document.on('click', '.row-navigation tbody tr', function (event) {
    if (!$(event.target).closest('a, button').length) {
      const $link = $(this).find('a').not('[href=\'#\']').not('[href=\'javascript:\']');
      const href = $link.attr('href');
      const target = $link.attr('target') || '_self';
      if (href) {
        window.open(href, target);
      }
    }
  });

  $document.on('change', '[data-auto-postback]', function () {
    $(this).closest('form').trigger('submit');
  });

  $document.on('click', '[data-print]', function () {
    window.print();
  });

  $document.on('click', '.card .btn-close', function () {
    if ($(this).attr('data-bs-dismiss')) {
      return;
    }
    $(this).closest('.card').hide();
  });

  $document.on('change', '.document-attachment input[type=file]', function () {
    const file = $(this).get(0).files[0];
    const $attachment = $(this).closest('.document-attachment');
    $attachment.find('.selected-document-file-name').text(file?.name ?? '');
    $attachment.find('.document-id').val('');
  });

  $document.on('click', '[href=\'#\']', function (e) {
    e.preventDefault();
  });

  $document.on('click', '.folder a, .folder input, .folder label, .treeview', function (e) {
    e.stopPropagation();
  });

  $document.on('click', '.folder', function (e) {
    e.stopPropagation();
    $(this).toggleClass('expand');
  });

  $document.on('click', '.file-picker .btn', function (e) {
    e.stopPropagation();

    $(this).closest('.file-picker').toggleClass('expand');
    var placeholder = $(this).siblings('.loader-container');
    if (placeholder.length) {
      var url = placeholder.data('url');
      var content = window.ifunds.filePickerCache[url];
      if (!content) {
        $.get(url, function (data) {
          window.ifunds.filePickerCache[url] = data;
          placeholder.replaceWith(data);
        });
      } else {
        placeholder.replaceWith(content);
      }
    }
  });

  $document.on('click', function () {
    $('.file-picker').removeClass('expand');
  });

  $document.on('click', '.file a', function (e) {
    e.preventDefault();
    var $attachment = $(this).closest('.document-attachment');
    $attachment.find('.file-picker').removeClass('expand');
    $attachment.find('.selected-document-file-name').text($(this).data('filename'));
    $attachment.find('.document-id').val($(this).data('id'));
    $attachment.find('input[type=file]').val('');
  });

  $document.on('click', '[data-attachment-id]', function (e) {
    e.preventDefault();
    const $el = $(e.target);
    $.ajax({
      url: window.rootUrl + '/api/attachment/toggleLock/' + $el.data('attachment-id'),
      type: 'PUT',
      success: function (isLocked) {
        $el.toggleClass('text-success', !isLocked);
        $el.toggleClass('text-danger', isLocked);
      }
    });
  });

  $document.on('click', '[data-clipboard]', async (e) => {
    e.stopPropagation();
    await navigator.clipboard.writeText($(e.target).closest('a').data('clipboard'));
  });

  $('.text-truncate').each(function () {
    const title = $(this).text().trim();
    if (title) {
      $(this).attr('title', title);
    }
  });

  $('[title]').filter(function () {
    return $(this).attr('title').trim().length > 0;
  }).tooltip({
    delay: { show: 600, hide: 100 }
  });

  window.toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-bottom-center',
    preventDuplicates: false,
    onclick: null,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 5000,
    extendedTimeOut: 1000,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  };

  new Dropzone('dropzone');
});

$.validator.unobtrusive.adapters.add('filesize', ['maxsize'], function (options: any) {
  options.rules['filesize'] = { maxsize: options.params.maxsize };
  if (options.message) {
    options.messages['filesize'] = options.message;
  }
});

$.validator.addMethod("date", function () {
  return true;
});

$.validator.addMethod('filesize', function (value, element: HTMLInputElement, param) {
  if (value === '') {
    return true;
  }
  const maxsize = parseInt(param.maxsize);
  if (element.files && element.files[0] && element.files[0].size) {
    const filesize = element.files[0].size;
    return filesize <= maxsize;
  }
  return true;
});

$.validator.unobtrusive.adapters.addBool('iban');
$.validator.addMethod('iban', function (value, element) {
  return this.optional(element) || isValidIban(value);
});

$(document).on('blur', 'input[data-val-iban]', function () {
  this.value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/(.{4})(?=.)/g, '$1 ');
});

function isValidIban(input: string) {
  const iban = input.toUpperCase().replace(/[^A-Z0-9]/g, ''),
    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
  let digits;
  if (!code) {
    return false;
  }
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
    return String(letter.charCodeAt(0) - 55);
  });
  return mod97(digits) === 1;
}

function mod97(s: string) {
  let checksum: number = +s.slice(0, 2), fragment: string;
  for (let offset = 2; offset < s.length; offset += 7) {
    fragment = String(checksum) + s.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}

window.getValue = (name: string) => {
  const value = $('[name="' + name + '"]').val();
  const number = window.Globalize.numberParser()(value?.toString());
  return isNaN(number) ? value : number;
};
